import {
	hideLoadingScreen,
	router,
	setPageContent,
	showLoadingScreen,
} from "..";
import { sendVerificationCode } from "../api/send-verification-code";
import { verifyEmail } from "../api/verify-email";
import { locale } from "../locale";
import { objectToQueryString } from "../utils";
import { Bulma } from "../view/bulma";
import { centeredBox, successToast } from "../view/components";

/**
 * @param {import("navigo").Match | undefined} ctx
 */
function verifyEmailPage(ctx) {
	const email = Bulma.input({
		type: "email",
		value: ctx?.params?.email,
	});

	if (ctx?.params?.email) {
		// Update browser url, remove email from query params
		delete ctx.params.email;
		window.history.replaceState(null, "", ctx.url);
	}

	const verificationCode = Bulma.input({
		type: "text",
	});

	function onClickVerify() {
		showLoadingScreen();
		verifyEmail(email.getValue(), verificationCode.getValue())
			.then(() => {
				router.jump(
					`/sign-in${objectToQueryString({
						email: email.getValue(),
					})}`,
				);
			})
			.finally(hideLoadingScreen);
	}

	const onclickResend = () => {
		showLoadingScreen();
		sendVerificationCode(email.getValue())
			.then(successToast)
			.finally(hideLoadingScreen);
	};

	setPageContent(
		centeredBox(
			"small",
			Bulma.title(locale.strings.verifyAccount),
			Bulma.title(
				locale.string({
					enGB: "If you cannot find the verification code email in your inbox, please check your spam folder. Requesting a new verification code will invalidate all previously issued codes.",
					deDE: "Wenn Sie die E-Mail mit dem Verifizierungscode nicht in Ihrem Posteingang finden, überprüfen Sie bitte Ihren Spam-Ordner. Wenn Sie einen neuen Verifizierungscode anfordern, werden alle zuvor ausgestellten Codes ungültig.",
					frFR: "Si vous ne trouvez pas le code de vérification dans votre boîte de réception, veuillez vérifier votre dossier de courrier indésirable. La demande d'un nouveau code de vérification invalidera tous les codes précédemment émis.",
					svSE: "Om du inte hittar e-postmeddelandet med verifieringskoden i din inkorg, kontrollera din skräppostmapp. Om du begär en ny verifieringskod kommer alla tidigare utfärdade koder att ogiltigförklaras.",
				}),
				"is-6",
			),
			Bulma.field(
				{},
				Bulma.label(locale.strings.email),
				Bulma.control({}, email.element),
			),
			Bulma.field(
				{},
				Bulma.label(locale.strings.verificationCode),
				Bulma.control({}, verificationCode.element),
			),
			Bulma.buttons(
				Bulma.button(
					{
						onClick: onclickResend,
						styles: ["is-primary"],
					},
					locale.string({
						enGB: "Send new verification code",
						deDE: "Neuen Verifizierungscode senden",
						frFR: "Envoyer un nouveau code de vérification",
						svSE: "Skicka ny verifieringskod",
					}),
				),
			),
			document.createElement("hr"),
			Bulma.buttons(
				Bulma.button(
					{
						onClick: onClickVerify,
						styles: ["is-primary"],
					},
					locale.strings.confirm,
				),
				Bulma.button(
					{
						onClick: () => router.jump("/sign-in"),
						styles: ["is-primary"],
					},
					locale.strings.cancel,
				),
			),
		),
	);
}

export { verifyEmailPage };
